import { Tooltip } from 'bootstrap'

export default {
    mounted(el) {
        el._tooltip = new Tooltip(el)
    },

    unmounted(el) {
        if (el._tooltip) {
            el._tooltip.dispose()
        }
    }
}
